import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { formatMoney } from '@shopify/theme-currency';
import * as cart from '@shopify/theme-cart';
// eslint-disable-next-line no-unused-vars
import MiniCartItem from './miniCartItem';
// eslint-disable-next-line no-unused-vars
import MiniCartItemLoader from './miniCartItemLoader';

const MiniCart = () => {
  const [cartData, setCartData] = useState();
  const [contentData, setcontentData] = useState();
  const [freeShipping, setFreeShipping] = useState({});
  const [cartRefreshed, setCartRefreshed] = useState(false);
  const [cartLoaded, setCartLoaded] = useState(false);
  const [nostoID, setNostoID] = useState();

  const miniCartData = JSON.parse(
    document.querySelector('[data-minicart-data]').innerHTML,
  );

  const minicartDisable =
    document.querySelector('body').dataset.disableMinicart;

  useEffect(() => {
    setNostoID(miniCartData.miniCart.cart_nosto_id);
    getCartState();
  }, [cartRefreshed]);

  const getCartState = () => {
    cart.getState().then((data) => {
      window.cart = data;
      var cartCount = document.querySelector('[data-cart-count]');
      if (cartCount !== null) {
        cartCount.innerHTML = data.item_count;
      }

      let nostoID = miniCartData.cart_nost_id;

      let freeShippingThreshold =
          parseInt(miniCartData.miniCart.free_shipping_purchase_amount) * 100,
        widthValue,
        diff = data.total_price - freeShippingThreshold,
        diff_money;

      if (diff < 0) {
        widthValue = (data.total_price / freeShippingThreshold) * 100 + '%';
        diff_money = formatMoney(diff * -1, '${{amount}}');
      } else {
        widthValue = '100%';
        diff_money = formatMoney(0, '${{amount}}');
      }

      let freeShippingObj = {
          width: widthValue,
          freeShippingPurchaseText:
            miniCartData.miniCart.free_shipping_purchase_text.replace(
              '%price',
              diff_money,
            ),
          freeShippingReachedText:
            miniCartData.miniCart.free_shipping_reached_text,
          freeShippingThreshold,
        },
        contentObj = {
          emptyCartCopy: miniCartData.miniCart.empty_cart_content,
          emptyCartCTACopy: miniCartData.miniCart.empty_cart_cta_copy,
          emptyCartCTAUrl: miniCartData.miniCart.empty_cart_cta_url,
        };

      setcontentData(contentObj);
      setFreeShipping(freeShippingObj);
      setCartData(data);
      setCartLoaded(true);
    });
  };

  useEffect(() => {
    if (!Element.prototype.closest) {
      if (!Element.prototype.matches) {
        Element.prototype.matches =
          Element.prototype.msMatchesSelector ||
          Element.prototype.webkitMatchesSelector;
      }
      Element.prototype.closest = function (s) {
        var el = this;
        var ancestor = this;
        if (!document.documentElement.contains(el)) return null;
        do {
          if (ancestor.matches(s)) return ancestor;
          ancestor = ancestor.parentElement;
        } while (ancestor !== null);
        return null;
      };
    }
    var settings = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',
    };

    var toggleAccessibility = function (event) {
      if (event.getAttribute('aria-expanded') === 'true') {
        event.setAttribute('aria-expanded', false);
      } else {
        event.setAttribute('aria-expanded', true);
      }
    };

    var openMiniCart = function (trigger) {
      var target = document.getElementById(
        trigger.getAttribute('aria-controls'),
      );
      target.classList.add(settings.activeClass);

      toggleAccessibility(trigger);

      document.querySelector('.mini-cart__shipping__progress').style.width =
        '0%';

      if (
        document.querySelectorAll('.mini-cart__buttons ul li').length == 0 &&
        document.querySelector('.dynamic-checkout__content') != null
      ) {
        document.querySelector('.dynamic-checkout__content').style.display =
          'none';
      }

      setTimeout(() => {
        document.querySelector('.mini-cart__shipping__progress').style.width =
          document.querySelector(
            '.mini-cart__shipping__progress',
          ).dataset.width;
      }, 300);

      setTimeout(function () {
        target.classList.add(settings.visibleClass);
      }, settings.speedOpen);
    };

    const handleHeaderUpdate = () => {
      const headerCart = document.querySelector('.header__cart-count');
      const cartItems = document.querySelectorAll('.mini-cart__item-count');
      let newHeaderCartCount = 0;
      if (cartItems.length != 0) {
        cartItems.forEach((item) => {
          newHeaderCartCount += parseInt(item.innerHTML);
        });
      }
      headerCart.innerHTML = newHeaderCartCount;
    };

    var closeMiniCart = function (event) {
      var closestParent = event.closest(settings.selectorTarget),
        childrenTrigger = document.querySelector(
          '[aria-controls="' + closestParent.id + '"',
        );
      closestParent.classList.remove(settings.visibleClass);
      document.documentElement.style.overflow = '';
      toggleAccessibility(childrenTrigger);
      setTimeout(function () {
        closestParent.classList.remove(settings.activeClass);
        document.querySelector('.mini-cart__shipping__progress').style.width =
          '0%';
      }, settings.speedClose);
    };

    let cartRecurring = function (index, array) {
      cart
        .addItem(
          parseInt(Object.keys(array[index])[0]),
          array[index][Object.keys(array[index])[0]],
        )
        .then((item) => {
          index = index + 1;
          if (array[index]) {
            cartRecurring(index, array);
          } else {
            getCartState();
          }
        })
        .catch((error) => {
          console.log(error);
          setCartLoaded(true);
        });
    };

    var clickHandler = function (event) {
      let clickTime = Date.now();
      var toggle = event.target,
        open = toggle.closest(settings.selectorTrigger),
        button_element,
        close = toggle.closest(settings.selectorClose);

      let path = event.composedPath();

      for (let i = 0; i < path?.length; i++) {
        if (
          path[i]?.dataset?.selectedVariant != undefined ||
          path[i]?.dataset?.productAddKit != undefined
        ) {
          button_element = path[i];
          break;
        } else if (path[i].dataset?.openSizes != undefined) {
          button_element = path[i];
          break;
        } else if (path[i].dataset?.variantAvailable != undefined) {
          button_element = path[i];
          break;
        }
      }

      if (
        button_element &&
        button_element.getAttribute('data-selected-variant') !== null
      ) {
        if (button_element.classList.contains('active')) {
          return;
        }
        setCartLoaded(false);
        let itemId = parseInt(
          button_element.getAttribute('data-selected-variant'),
        );
        let properties, itemData;
        if (button_element.hasAttribute('data-compare-price-item')) {
          properties = {
            _product_compare: button_element.getAttribute(
              'data-compare-price-item',
            ),
            _product_price: button_element.getAttribute('data-price-item'),
          };
          itemData = { quantity: 1, properties };
        } else {
          itemData = { quantity: 1 };
        }
        cart
          .addItem(itemId, itemData)
          .then((itemData) => {
            let itemTrack = {
              Name: itemData.product_title,
              ProductID: itemData.product_id,
              Categories: '',
              ImageURL: itemData.image,
              URL: 'https://reef-admin.myshopify.com' + itemData.url,
              Brand: itemData.vendor,
              Price: formatMoney(itemData.price, '${{amount}}'),
              CompareAtPrice: formatMoney(
                itemData.original_price > itemData.price
                  ? itemData.original_price
                  : 0,
                '${{amount}}',
              ),
            };
            _learnq.push(['track', 'Added to Cart', itemTrack]);
            getCartState();
          })
          .catch((error) => {
            console.log(error);
            setCartLoaded(true);
          });
        let cartCount = parseInt(
          document.querySelector('.header__cart-count').innerHTML,
        );
        document.querySelector('.header__cart-count').innerHTML = cartCount + 1;
      } else if (
        button_element &&
        button_element.hasAttribute('data-product-add-kit')
      ) {
        if (button_element.classList.contains('active')) {
          return;
        }
        setCartLoaded(false);
        let itemsToAdd = [];
        document
          .querySelectorAll('[data-selected-kit-variant]')
          .forEach((kitItem) => {
            let itemId = parseInt(
              kitItem.getAttribute('data-selected-kit-variant'),
            );
            let properties,
              itemData,
              item = {};
            if (kitItem.hasAttribute('data-compare-price-item')) {
              properties = {
                _product_compare: kitItem.getAttribute(
                  'data-compare-price-item',
                ),
                _product_price: kitItem.getAttribute('data-price-item'),
                _is_bundle_item: true,
                _products_in_bundle: parseInt(
                  document
                    .querySelector('[data-bundle-count]')
                    .getAttribute('data-bundle-count'),
                ),
                _click_time: clickTime,
                _bundleHandle: document
                  .querySelector('[data-product-handle]')
                  .getAttribute('data-product-handle'),
                _bundlePrice: parseInt(
                  document
                    .querySelector('[data-product-handle]')
                    .getAttribute('data-bundle-price'),
                ),
              };
              itemData = { quantity: 1, properties };
            } else {
              itemData = { quantity: 1 };
            }
            item[itemId] = itemData;
            itemsToAdd.push(item);
          });
        let i = 0;
        cartRecurring(i, itemsToAdd);
      }

      if (!minicartDisable) {
        if (open) {
          // Don't open drawer cart on cart page
          if (document.body.classList.contains('template-cart')) {
            window.location = '/cart';
          } else {
            openMiniCart(open);
            document.querySelector('body')?.classList?.add('disable-scroll');
          }
        }
        if (close) {
          handleHeaderUpdate();
          closeMiniCart(close);
          document.querySelector('body')?.classList?.remove('disable-scroll');
        }
      }

      if (open || close) {
        event.preventDefault();
      }
    };

    var keydownHandler = function (event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        var drawers = document.querySelectorAll(settings.selectorTarget),
          i;
        for (i = 0; i < drawers.length; ++i) {
          if (drawers[i].classList.contains(settings.activeClass)) {
            closeMiniCart(drawers[i]);
          }
        }
      }
    };

    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);
  }, []);

  const handleRefreshCart = (key = 0, state = []) => {
    setCartRefreshed(!cartRefreshed);
  };
  const handleCartLoaded = () => {
    setCartLoaded(false);
  };

  return (
    <div className="mini-cart__wrapper" data-version="v.1.0">
      <div className="mini-cart__header">
        <div className="mini-cart__title mini-cart__label">SHOPPING BAG</div>
        <div
          className="mini-cart__close"
          data-drawer-close
          aria-label="Close Drawer"
        ></div>
      </div>
      <div className="mini-cart__content">
        <div className="mini-cart__shipping">
          {freeShipping?.width != '100%' ? (
            <p>{freeShipping.freeShippingPurchaseText}</p>
          ) : (
            <p>{freeShipping.freeShippingReachedText}</p>
          )}
          <div className="mini-cart__shipping__progress-wrap">
            <div
              className="mini-cart__shipping__progress"
              data-width={freeShipping.width}
              style={{ width: freeShipping.width }}
            ></div>
          </div>
        </div>
        <div
          id="mini-cart__drawer"
          data-empty={`${cartData?.items?.length == 0 ? 'empty' : ''}`}
        >
          {cartData?.items?.length ? (
            <div id="mini-cart__items-list">
              {cartData?.items?.map((item) =>
                cartLoaded ? (
                  <MiniCartItem
                    item={item}
                    key={`cart-item-${item.key}`}
                    handleRefreshCart={handleRefreshCart}
                    handleCartLoaded={handleCartLoaded}
                    miniCartData={miniCartData}
                    items={cartData.items}
                  />
                ) : (
                  <MiniCartItemLoader key={`cart-item-loader-${item.key}`} />
                ),
              )}
            </div>
          ) : (
            <div className="mini-cart__items-empty">
              <div className="mini-cart__items-empty-title">
                {contentData?.emptyCartCopy}
              </div>
              <div
                className="mini-cart__items-empty-link"
                aria-label={contentData?.emptyCartCTACopy}
              >
                <a href={contentData?.emptyCartCTAUrl}>
                  {contentData?.emptyCartCTACopy}
                </a>
              </div>
            </div>
          )}
        </div>
        <div
          className="nosto_element mini-cart__recommendations"
          id={nostoID}
        ></div>
      </div>
      {cartData?.items?.length ? (
        <div className="mini-cart__total">
          <div className="mini-cart__total-top">
            <div className="mini-cart__label">Subtotal</div>
            <div className="mini-cart__label" id="mini-cart__total-price">
              {formatMoney(
                cartData?.total_price ? cartData.total_price : 0,
                '${{amount}}',
              )}
            </div>
          </div>
          <div className="mini-cart__buttons">
            <a id="mini-cart__checkout-btn" href="/checkout" className="btn">
              SECURE CHECKOUT
            </a>
            <div
              className="dynamic-checkout__content"
              id="dynamic-checkout-cart"
              data-shopify="dynamic-checkout-cart"
            ></div>
          </div>
          <p className="mini-cart__taxes">
            Shipping + Taxes calculated in Checkout
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default MiniCart;
let mini_cart_DOM = document.createElement('section');
mini_cart_DOM.classList.add('mini-cart');
mini_cart_DOM.setAttribute('data-drawer-target', '');
mini_cart_DOM.setAttribute('id', 'mini-cart');
let mini_cart_container = document.createElement('div');
let mini_cart_overlay = document.createElement('div');
mini_cart_overlay.classList.add('mini-cart__overlay');
mini_cart_overlay.setAttribute('data-drawer-close', 'true');
mini_cart_overlay.setAttribute('aria-label', 'Close Drawer');
mini_cart_container.setAttribute('id', 'mini-cart-component');
mini_cart_DOM.appendChild(mini_cart_container);
mini_cart_DOM.appendChild(mini_cart_overlay);
window.addEventListener('load', (event) => {
  document.querySelector('body').appendChild(mini_cart_DOM);
  ReactDOM.render(<MiniCart />, document.getElementById('mini-cart-component'));
});
